import React from "react";
import { DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Standard modal header: title on the left, an X close button on the
 * right. Modals close via this X only — there is no separate Cancel
 * button (see ModalActions).
 */
const ModalDialogTitle = ({ children, onClose, ...otherProps }) => (
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
    {...otherProps}
  >
    <span>{children}</span>
    <IconButton
      aria-label="close"
      onClick={onClose}
      edge="end"
      size="large"
      sx={{ color: (theme) => theme.palette.grey[500] }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
);

export default ModalDialogTitle;
